import { useNavigate } from "react-router";
import { CustomButton } from "../CustomButton/CustomButton";
import { GoBack } from "../GoBack/GoBack";
import { BsFiletypeXls } from "react-icons/bs";
import { API_URLs } from "../../../utilities/API_URLs";
import { API_BASE_URL_IMAGE } from "../../../utilities/API_CONSTANT";
import Cookies from "universal-cookie";
import React from "react";

type TitleHeaderType = {
  isSHowBack?: boolean;
  backUri?: string;
  title: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  isEnableExportExcel?: boolean;
  isEnableAdd?: boolean;
  exportUri?: string;
  addText?: string;
  addChildren?: React.ReactNode;
  onClickOnAdd?: () => void;
  children?: React.ReactNode;
};

export const TitleHeader = ({
  isSHowBack,
  backUri,
  title,
  isEnableExportExcel,
  isEnableAdd,
  exportUri,
  addChildren,
  subTitle,
  onClickOnAdd,
  children,
}: TitleHeaderType) => {
  const navigate = useNavigate();

  const downloadAsExcel = () => {
    // const p: Array<any> = [];
    let pars = "?";
    //   columns?.forEach((c, ik) => {
    //     if (c.show) {
    //       pars += c.nestedKey
    //         ? c.nestedKeyAsParam + "&"
    //         : "p[]=" +
    //           (c.dataIndex ?? "") +
    //           (ik < columns.length - 1 ? "&" : "&");
    //     }
    //   });
    const url = exportUri + ".global-listing-spreadsheet" + pars;
    const cookies = new Cookies(document.cookie, { path: "/" });
    const authorizationData = cookies.get("auth_data");
    let headers: any = null;
    if (authorizationData) {
      headers = {
        Authorization: "Bearer " + authorizationData.token,
      };
    }
    fetch(API_BASE_URL_IMAGE + url, {
      method: "GET",
      headers: headers,
    })
      .then((res) => res.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `sems-role.xlsx`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link?.parentNode?.removeChild(link);
      });
  };

  return (
    <div className="pt-4">
      <div className="">
        {(isSHowBack || subTitle) && (
          <div className="d-flex align-items-center gap-2 mb-4">
            {isSHowBack ? (
              <div className="">
                <GoBack uri={backUri} />
              </div>
            ) : (
              ""
            )}
            {subTitle ? (
              <div>
                {" "}
                <span className="fst-italic ">{subTitle}</span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
        <div className="d-flex gap-4">
          <div className="d-flex gap-2">
            <h4>{title}</h4>
            {children}
          </div>
          <div className="d-flex">
            {isEnableExportExcel ? (
              <div className="m-1 p-1 cursor-pointer" onClick={downloadAsExcel}>
                <BsFiletypeXls size={20} />
              </div>
            ) : (
              ""
            )}
            {isEnableAdd ? (
              <CustomButton
                className="d-flex align-items-center justify-content-center p-2 gap-2"
                style={{
                  width: "100px",
                }}
                onClick={() => {
                  onClickOnAdd ? onClickOnAdd() : navigate("add");
                }}
              >
                {addChildren ?? (
                  <div>
                    <span className="fw-semibold">Nouveau</span>
                  </div>
                )}
              </CustomButton>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
